require('./globalPositionExpensesGraph.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter, Link } = require('react-router-dom');
const {
    Component
} = require('react');

const classNames = require('classnames');
const { OKLink } = require('commonsComponents/OKLink');
const { formatText } = require('core/i18n').i18n;

// @components
const GlobalPositionExpensesBars = require('./globalPositionExpensesBars/globalPositionExpensesBars');

// @helpers
const { formatAmount } = require('utilities/currencyHelper');
const { FormattedText } = require('core/i18n').i18n;

// @constants
const { GP_EXPENSES_FILTER_COMPARE_NONE, EURO_SYMBOL } = require('constants/index');
const { getCategoryIcon } = require('constants/categories');
const GP_EXPENSES_CATEGORIES_LIMIT = 5;

class GlobalPositionExpensesGraph extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };

        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle() {
        this.setState({
            expanded: !this.state.expanded
        });
    }

    onNavigateToExpensesByCategoryView(category) {
        this.props.history.push(`/myprofile/global/expenses-by-category/${ category }`);
    }

    render() {
        const { immExpenses } = this.props;
        const currencySymbol = EURO_SYMBOL; // The componente only supports EUROS for now
        const immBaseData = immExpenses.get('expenses');
        const filterType = immExpenses.get('filters').get('type');
        let filterTypePG;
        switch (filterType) {
          case "ACCOUNTS":
            filterTypePG = formatText('urlGobalPosition-debitAccount');
            break;
          case "CARDS":
            filterTypePG = formatText('urlGobalPosition-creditAccount');
            break;
          default:
            filterTypePG = formatText('urlGobalPosition-bothAccount');
        }
        const filterAccountType = immExpenses.get('filters').get('typeAccount') === 'custom' ? formatText('urlGobalPosition-customAccounts') : formatText('urlGobalPosition-allAccounts');
        const showCompare =
            immExpenses.get('filters').get('compare') !== GP_EXPENSES_FILTER_COMPARE_NONE;
        let totalCurrentPeriod = 0;
        let countList = 0;

        const categoriesOrder = immBaseData.get('categoriesOrder');

        // Get max value of all categories
        categoriesOrder.forEach(category => {
            if (showCompare) {
                totalCurrentPeriod = Math.max(
                    totalCurrentPeriod,
                    Math.abs(
                        immBaseData.getIn(['currentPeriod', 'byCategory', filterType, category]) ||
                            0
                    ),
                    Math.abs(
                        immBaseData.getIn(['previousPeriod', 'byCategory', filterType, category]) ||
                            0
                    )
                );
            } else {
                totalCurrentPeriod = Math.max(
                    totalCurrentPeriod,
                    Math.abs(
                        immBaseData.getIn(['currentPeriod', 'byCategory', filterType, category]) ||
                            0
                    )
                );
            }
        });

        // TODO: check if this reduce() makes sense here
        let expensesListRendered = categoriesOrder.reduce((list, category) => {
            const currentPeriod =
                immBaseData.getIn(['currentPeriod', 'byCategory', filterType, category]) || 0;

            let previousPeriod;
            if (showCompare) {
                previousPeriod =
                    immBaseData.getIn(['previousPeriod', 'byCategory', filterType, category]) || 0;
            }

            if (currentPeriod || (showCompare && previousPeriod)) {
                const iconClasses = classNames(
                    'global-position-expenses-graph__expense-icon',
                    getCategoryIcon(category)
                );
                const iconElement = (
                    <div className="global-position-expenses-graph__icon-column">
                        <i
                            className={iconClasses}
                            onClick={() => this.onNavigateToExpensesByCategoryView(category)}
                        />
                    </div>
                );

                let compareValueComponent;
                if (showCompare) {
                    compareValueComponent = (
                        <span className="global-position-expenses-graph__previous-amount">
                            {formatAmount(previousPeriod)} {currencySymbol}
                        </span>
                    );
                }
                if (countList < GP_EXPENSES_CATEGORIES_LIMIT) {
                    list.push(
                        <Link to={`/myprofile/global/expenses-by-category/${category}/${filterTypePG}/${filterAccountType}`} className="global-position-expenses-graph__link-box">
                            <li
                                key={category}
                                className={`${previousPeriod !== undefined ? 'global-position-expenses-graph__expenses-list-row-expanded' : 'global-position-expenses-graph__expenses-list-row'}`}>
                                {iconElement}
                                <div className="global-position-expenses-graph__bars-column">
                                    <OKLink to={`/myprofile/global/expenses-by-category/${category}/${filterTypePG}/${filterAccountType}`} modifier="widget">
                                        <FormattedText
                                            value={`categories-${category}`}
                                            className="global-position-expenses-graph__category-text"
                                        />
                                    </OKLink>
                                    <GlobalPositionExpensesBars
                                        maxExpenses={totalCurrentPeriod}
                                        currentPeriod={currentPeriod}
                                        comparePeriod={previousPeriod}
                                    />
                                </div>
                                <div className="global-position-expenses-graph__amount-column">
                                    <span className="global-position-expenses-graph__current-amount">
                                        {' '}{formatAmount(currentPeriod)} {currencySymbol}
                                    </span>
                                    {compareValueComponent}
                                </div>
                            </li>
                        </Link>
                    );
                    countList += 1;
                }
            }

            return list;
        }, []);

        let toggleContent;
        let withoutToggle = true;
        // If there's more categories to render than defined limit, we show the toggle section

        let toggleLabelKey = 'globalPositionExpenses-showMore';


        toggleContent = (
            <div className="global-position-expenses-graph__toggle">
                <OKLink to={`/myprofile/global/expenses-by-category/all-categories/${filterTypePG}/${filterAccountType}`} modifier="widget">
                    <FormattedText
                        value={toggleLabelKey}
                        className="global-position-expenses-graph__toggle--text"
                    />
                </OKLink>
            </div>
        );

        const listContainerClasses = classNames('global-position-expenses-graph__list-container', {
            'global-position-expenses-graph__list-container--without-toggle': withoutToggle,
            'global-position-expenses-graph__list-container-transition': !withoutToggle,
            'global-position-expenses-graph__list-container-transition--is-expanded':
                !withoutToggle && this.state.expanded
        });

        return (
            <div className="col-xs-12 global-position-expenses-graph">
                <div className={listContainerClasses}>
                    <ul className="global-position-expenses-graph__expenses-list">
                        {expensesListRendered}
                    </ul>
                </div>
                {toggleContent}
            </div>
        );
    }
}

GlobalPositionExpensesGraph.propTypes = {
    history: PropTypes.object.isRequired,
    immExpenses: PropTypes.object,
};

module.exports = withRouter(GlobalPositionExpensesGraph);
